import React, { useLayoutEffect } from "react";
import { useTranslation } from "react-i18next";
import BannerSection from "../BannerSection/BannerSection";

const Productos = () => {

    useLayoutEffect(() => {
                window.scrollTo(0, 0)
            });

            const { t, i18n } = useTranslation();
            const isEnglish = i18n.language === "en";

    return (
        <section className="productos">
            <BannerSection />
            <div className="container-intro">
                <article>
                    {t("productos.intro1")}
                </article>
                <h2>
                    {t("productos.h2")}
                </h2>
                <article>
                    {t("productos.intro2")}
                </article>
            </div>

            <div className="container-items">
                <div className="item-card">
                    <img src="../../assets/img/p-captura.webp" alt={t("productos.captura")} title={t("productos.captura")}/>
                    <div className="container-txt">
                        <h3>
                            {t("productos.captura")}
                        </h3>
                        <article>
                            {t("productos.capturatxt1")}
                            <br/><br/>
                            {t("productos.capturatxt2")}
                        </article>
                    </div>
                </div>
                <div className="item-card">
                    <img src="../../assets/img/p-logistica.webp" alt={t("productos.logistica")} title={t("productos.logistica")}/>
                    <div className="container-txt">
                        <h3>
                            {t("productos.logistica")}
                        </h3>
                        <article>
                            {t("productos.logisticatxt1")}
                            <br/><br/>
                            {t("productos.logisticatxt2")}
                        </article>
                    </div>
                </div>
                <div className="item-card">
                    <img src="../../assets/img/p-congelado.webp" alt={t("productos.congelado")} title={t("productos.congelado")}/>
                    <div className="container-txt">
                        <h3>
                            {t("productos.congelado")}
                        </h3>
                        <article>
                            {t("productos.congeladotxt1")}
                            <br/><br/>
                            {t("productos.congeladotxt2")}
                        </article>
                    </div>
                </div>
            </div>

            <div className="container-productos">
                <div className="intro-productos">
                    <h3>
                        {t("productos.entero")}
                    </h3>
                    <article>
                        {t("productos.enterotxt")}
                    </article>
                </div>
                <img src={
                    isEnglish
                    ? "/assets/img/p-langostino-enteroEN.webp"
                    : "/assets/img/p-langostino-entero.webp"
                } alt={t("productos.entero")} title={t("productos.entero")}/>

                <div className="intro-productos">
                    <h3>
                        {t("productos.cola")}
                    </h3>
                    <article>
                        {t("productos.colatxt")}
                    </article>
                </div>
                <img src={
                    isEnglish
                    ? "/assets/img/p-langostino-colaEN.webp"
                    : "/assets/img/p-langostino-cola.webp"
                } alt={t("productos.cola")} title={t("productos.cola")}/>

                <div className="intro-productos">
                    <h3>
                        {t("productos.pelado")}
                    </h3>
                    <article>
                        {t("productos.peladotxt")}
                    </article>
                </div>
                <img src={
                    isEnglish
                    ? "/assets/img/p-langostino-peladoEN.webp"
                    : "/assets/img/p-langostino-pelado.webp"
                } alt={t("productos.pelado")} title={t("productos.pelado")}/>

                <div className="intro-productos">
                    <h3>
                        {t("productos.merluza")}
                    </h3>
                    <article>
                        {t("productos.merluzatxt")}
                    </article>
                </div>
                <img src={
                    isEnglish
                    ? "/assets/img/p-merluzaEN.webp"
                    : "/assets/img/p-merluza.webp"
                } alt={t("productos.merluza")} title={t("productos.merluza")}/>
            </div>

        </section>
    );
}

export default Productos;
